import templateUrl from './adverse-event-search.html';

export default {
  templateUrl,
  bindings: {
    animalTypes: '<',
    eventTypes: '<',
    searchTypes: '<',
    searchCriteria: '<',
    onSearchCriteriaChanged: '&',
    onSearchTextChanged: '&',
    onSearchByTextChanged: '&'
  },
  controller: class AdverseEventSearchComponent {
    constructor(EventEmitter, ProductService) {
      'ngInject';

      Object.assign(this, { EventEmitter, ProductService });
    }

    $onChanges(changes) {
      if (changes.searchCriteria) {
        this.searchCriteria = Object.assign({}, this.searchCriteria);
      }
    }

    onChange() {
      this.onSearchCriteriaChanged(
        this.EventEmitter({
          searchCriteria: this.searchCriteria
        })
      );
    }

    onSearchTextChange(text) {
      this.onSearchTextChanged(
        this.EventEmitter({
          searchText: text
        })
      );
    }

    onSearchByTextChange(text) {
      this.onSearchByTextChanged(
        this.EventEmitter({
          searchByText: text
        })
      );
    }

    selectedIngredientChanged($event) {
      this.searchCriteria.selectedIngredient = $event.selectedIngredient;
      this.onChange();
    }

    searchProducts(name) {
      return this.ProductService.searchProductsByName(name).then(r => r.data);
    }

    selectedMemberChanged($event) {
      this.searchCriteria.selectedCompany = $event.company;
      this.onChange();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-event-search/adverse-event-search.component.js